import {createRequestDataSource} from '@ngneat/elf-requests';
import {organisationsConfigStore} from '@store/settings/organisationsConfig/organisationsConfig.store';
import {selectAllEntities} from '@ngneat/elf-entities';

export const getOrganisationsConfigDataSource = createRequestDataSource({
  store: organisationsConfigStore,
  data$: () => organisationsConfigStore.pipe(
    selectAllEntities(),
  ),
  requestKey: 'getOrganisationsConfig',
  dataKey: 'organisationsConfig',
});
